import Menu from './scheduler_manage.vue';

export default Menu;
